import React, { useState } from 'react';
import '../../styles/midnight-lab.css';

function CalendarModule() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [events, setEvents] = useState([
    { id: 1, title: 'Team Meeting', start: '2025-01-20T15:00', end: '2025-01-20T16:00', type: 'meeting', color: 'var(--color-frozen-lake)' },
    { id: 2, title: 'Competition: Regional Qualifier', start: '2025-01-25T09:00', end: '2025-01-25T17:00', type: 'competition', color: 'var(--color-yellow-green)' },
    { id: 3, title: 'Build Session', start: '2025-01-22T14:00', end: '2025-01-22T18:00', type: 'build', color: 'var(--color-frozen-lake)' },
    { id: 4, title: 'Deadline: Order Parts', start: '2025-01-18T23:59', end: '2025-01-18T23:59', type: 'deadline', color: 'var(--color-yellow-green)' }
  ]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newEvent, setNewEvent] = useState({
    title: '', start: '', end: '', type: 'meeting'
  });

  const eventTypeColors = {
    meeting: 'var(--color-frozen-lake)',
    competition: 'var(--color-yellow-green)',
    build: 'var(--color-frozen-lake)',
    deadline: 'var(--color-yellow-green)'
  };

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();
    
    const days = [];
    // Empty cells for days before month starts
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(null);
    }
    // Days of the month
    for (let i = 1; i <= daysInMonth; i++) {
      days.push(new Date(year, month, i));
    }
    return days;
  };

  const getEventsForDate = (date) => {
    if (!date) return [];
    const dateStr = date.toISOString().split('T')[0];
    return events.filter(e => {
      const eventStart = e.start.split('T')[0];
      return eventStart === dateStr;
    });
  };

  const days = getDaysInMonth(currentDate);
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const handlePrevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };

  const handleAddEvent = () => {
    const event = { ...newEvent, id: events.length + 1, color: eventTypeColors[newEvent.type] };
    setEvents([...events, event]);
    setShowAddModal(false);
    setNewEvent({ title: '', start: '', end: '', type: 'meeting' });
  };

  return (
    <div>
      {/* Header */}
      <div style={{
        marginBottom: 'var(--space-8)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 'var(--space-4)'
      }}>
        <div>
          <h1 style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: 700,
            color: 'var(--color-text-primary)',
            marginBottom: 'var(--space-2)',
            letterSpacing: '-0.02em'
          }}>
            Calendar
          </h1>
          <p style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-base)',
            color: 'var(--color-text-secondary)'
          }}>
            View deadlines, meetings, competitions, and events
          </p>
        </div>
        <button
          onClick={() => setShowAddModal(true)}
          style={{
            padding: 'var(--space-3) var(--space-6)',
            backgroundColor: 'var(--color-text-primary)',
            color: 'var(--color-text-light)',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-sm)',
            fontWeight: 600,
            border: 'none',
            cursor: 'pointer',
            transition: 'all var(--transition-base)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'var(--color-frozen-lake)';
            e.target.style.color = 'var(--color-text-primary)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'var(--color-text-primary)';
            e.target.style.color = 'var(--color-text-light)';
          }}
        >
          + New Event
        </button>
      </div>

      {/* Calendar Navigation */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 'var(--space-6)',
        padding: 'var(--space-4)',
        borderBottom: '1px solid rgba(0, 16, 17, 0.1)'
      }}>
        <button onClick={handlePrevMonth} style={navButtonStyle}>←</button>
        <h2 style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-2xl)',
          fontWeight: 700,
          color: 'var(--color-text-primary)'
        }}>
          {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
        </h2>
        <button onClick={handleNextMonth} style={navButtonStyle}>→</button>
      </div>

      {/* Calendar Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: 'var(--space-2)',
        marginBottom: 'var(--space-8)'
      }}>
        {dayNames.map(day => (
          <div
            key={day}
            style={{
              padding: 'var(--space-3)',
              textAlign: 'center',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              fontWeight: 600,
              color: 'var(--color-text-secondary)',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}
          >
            {day}
          </div>
        ))}
        {days.map((date, index) => {
          const dayEvents = getEventsForDate(date);
          const isToday = date && date.toDateString() === new Date().toDateString();
          
          return (
            <div
              key={index}
              style={{
                minHeight: '120px',
                padding: 'var(--space-2)',
                border: '1px solid rgba(0, 16, 17, 0.1)',
                backgroundColor: isToday ? 'rgba(108, 207, 246, 0.1)' : 'var(--color-bg-primary)',
                position: 'relative'
              }}
            >
              {date && (
                <>
                  <div style={{
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-sm)',
                    fontWeight: isToday ? 700 : 400,
                    color: isToday ? 'var(--color-frozen-lake)' : 'var(--color-text-primary)',
                    marginBottom: 'var(--space-2)'
                  }}>
                    {date.getDate()}
                  </div>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 'var(--space-1)'
                  }}>
                    {dayEvents.slice(0, 3).map(event => (
                      <div
                        key={event.id}
                        style={{
                          padding: 'var(--space-1) var(--space-2)',
                          backgroundColor: event.color + '20',
                          borderLeft: `3px solid ${event.color}`,
                          fontFamily: 'var(--font-sans)',
                          fontSize: 'var(--text-xs)',
                          color: 'var(--color-text-primary)',
                          cursor: 'pointer',
                          transition: 'all var(--transition-base)',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = event.color + '40';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = event.color + '20';
                        }}
                        title={event.title}
                      >
                        {event.title}
                      </div>
                    ))}
                    {dayEvents.length > 3 && (
                      <div style={{
                        fontFamily: 'var(--font-sans)',
                        fontSize: 'var(--text-xs)',
                        color: 'var(--color-text-secondary)',
                        fontStyle: 'italic'
                      }}>
                        +{dayEvents.length - 3} more
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>

      {/* Upcoming Events List */}
      <div>
        <h2 style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-2xl)',
          fontWeight: 600,
          color: 'var(--color-text-primary)',
          marginBottom: 'var(--space-6)'
        }}>
          Upcoming Events
        </h2>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-4)'
        }}>
          {events
            .sort((a, b) => new Date(a.start) - new Date(b.start))
            .map(event => (
              <div
                key={event.id}
                style={{
                  padding: 'var(--space-4)',
                  borderLeft: `4px solid ${event.color}`,
                  borderBottom: '1px solid rgba(0, 16, 17, 0.1)',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div>
                  <div style={{
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-base)',
                    fontWeight: 600,
                    color: 'var(--color-text-primary)',
                    marginBottom: 'var(--space-1)'
                  }}>
                    {event.title}
                  </div>
                  <div style={{
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-sm)',
                    color: 'var(--color-text-secondary)',
                    textTransform: 'capitalize'
                  }}>
                    {event.type} • {new Date(event.start).toLocaleString()}
                  </div>
                </div>
                <div style={{
                  padding: 'var(--space-1) var(--space-3)',
                  backgroundColor: event.color + '20',
                  color: event.color,
                  fontFamily: 'var(--font-sans)',
                  fontSize: 'var(--text-xs)',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  borderRadius: '4px'
                }}>
                  {event.type}
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* Add Event Modal */}
      {showAddModal && (
        <div
          onClick={() => setShowAddModal(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 16, 17, 0.8)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 'var(--space-4)'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: 'var(--color-bg-primary)',
              padding: 'var(--space-8)',
              maxWidth: '600px',
              width: '100%'
            }}
          >
            <h2 style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-2xl)',
              fontWeight: 700,
              color: 'var(--color-text-primary)',
              marginBottom: 'var(--space-6)'
            }}>
              Create New Event
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
              <div>
                <label style={labelStyle}>Title</label>
                <input
                  type="text"
                  value={newEvent.title}
                  onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })}
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={labelStyle}>Type</label>
                <select
                  value={newEvent.type}
                  onChange={(e) => setNewEvent({ ...newEvent, type: e.target.value })}
                  style={inputStyle}
                >
                  <option value="meeting">Meeting</option>
                  <option value="competition">Competition</option>
                  <option value="build">Build Session</option>
                  <option value="deadline">Deadline</option>
                </select>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-4)' }}>
                <div>
                  <label style={labelStyle}>Start</label>
                  <input
                    type="datetime-local"
                    value={newEvent.start}
                    onChange={(e) => setNewEvent({ ...newEvent, start: e.target.value })}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>End</label>
                  <input
                    type="datetime-local"
                    value={newEvent.end}
                    onChange={(e) => setNewEvent({ ...newEvent, end: e.target.value })}
                    style={inputStyle}
                  />
                </div>
              </div>
            </div>
            <div style={{
              display: 'flex',
              gap: 'var(--space-4)',
              marginTop: 'var(--space-6)'
            }}>
              <button onClick={handleAddEvent} style={buttonStyle}>
                Create Event
              </button>
              <button onClick={() => setShowAddModal(false)} style={{ ...buttonStyle, backgroundColor: 'transparent', color: 'var(--color-text-primary)' }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const navButtonStyle = {
  padding: 'var(--space-2) var(--space-4)',
  backgroundColor: 'transparent',
  border: '1px solid rgba(0, 16, 17, 0.1)',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-lg)',
  cursor: 'pointer',
  transition: 'all var(--transition-base)',
  color: 'var(--color-text-primary)'
};

const labelStyle = {
  display: 'block',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-sm)',
  fontWeight: 600,
  color: 'var(--color-text-primary)',
  marginBottom: 'var(--space-2)'
};

const inputStyle = {
  width: '100%',
  padding: 'var(--space-3)',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-base)',
  border: '1px solid rgba(0, 16, 17, 0.1)',
  backgroundColor: 'var(--color-bg-primary)',
  color: 'var(--color-text-primary)'
};

const buttonStyle = {
  padding: 'var(--space-3) var(--space-6)',
  backgroundColor: 'var(--color-text-primary)',
  color: 'var(--color-text-light)',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-base)',
  fontWeight: 600,
  border: 'none',
  cursor: 'pointer',
  transition: 'all var(--transition-base)'
};

export default CalendarModule;

